import { render, staticRenderFns } from "./GameTemplate.vue?vue&type=template&id=67d4ce35&scoped=true&"
import script from "./GameTemplate.vue?vue&type=script&lang=js&"
export * from "./GameTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GameTemplate.vue?vue&type=style&index=0&id=67d4ce35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4ce35",
  null
  
)

export default component.exports